import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

/**
 * Encabezado de sección editorial — reemplaza el patrón "Typography
 * overline + Stack" repetido manualmente en DashboardPage/PulsePage/
 * SignalsPage (Fase C) por un único componente. Sin card, sin borde:
 * jerarquía por tipografía + espacio, no por contenedor (sección 9 del
 * encargo, "evitar el card syndrome").
 */
export function SectionHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700, letterSpacing: '0.08em' }}>
        {title}
      </Typography>
      {action}
    </Stack>
  )
}
